import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Phone } from 'lucide-react';
import { sitemapLinks, legalLinks } from '../../data/mock';
import { useLanguage } from '../../context/LanguageContext';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_5d2b1704-c912-40b5-94d1-19a432268dc7/artifacts/9p21esp1_logo-datasignz-creative-minds-%5BConverted%5D.png";

// TikTok icon component since lucide-react doesn't have it
const TikTokIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-[#6a6a6a]">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Column 1: Logo and Description */}
          <div>
            <img
              src={LOGO_URL}
              alt="Datasignz CreativeMinds"
              className="h-8 w-auto mb-3"
            />
            <p className="text-white text-xs font-montserrat leading-relaxed">
              {t('footerDesc')}
            </p>
            {/* Social Media Icons */}
            <div className="flex gap-3 mt-4">
              <a
                href="https://facebook.com/datasignz"
                target="_blank"
                rel="noopener noreferrer"
                className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors duration-300"
              >
                <Facebook className="w-3.5 h-3.5 text-white" />
              </a>
              <a
                href="https://tiktok.com/@datasignz"
                target="_blank"
                rel="noopener noreferrer"
                className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors duration-300"
              >
                <TikTokIcon className="w-3.5 h-3.5 text-white" />
              </a>
              <a
                href="https://instagram.com/datasignz"
                target="_blank"
                rel="noopener noreferrer"
                className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors duration-300"
              >
                <Instagram className="w-3.5 h-3.5 text-white" />
              </a>
              <a
                href="https://wa.me/597"
                target="_blank"
                rel="noopener noreferrer"
                className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors duration-300"
              >
                <Phone className="w-3.5 h-3.5 text-white" />
              </a>
            </div>
          </div>

          {/* Column 2: Sitemap */}
          <div>
            <h3 className="text-white font-montserrat-bold text-sm mb-3">{t('sitemap')}</h3>
            <ul className="space-y-1.5">
              {sitemapLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white text-xs font-montserrat hover:text-white/70 transition-colors duration-300"
                  >
                    {t(link.nameKey) || link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Legal */}
          <div>
            <h3 className="text-white font-montserrat-bold text-sm mb-3">{t('legal')}</h3>
            <ul className="space-y-1.5">
              {legalLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white text-xs font-montserrat hover:text-white/70 transition-colors duration-300"
                  >
                    {t(link.nameKey) || link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/20 py-3">
        <p className="text-white text-xs font-montserrat text-center">
          {t('copyright')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
